<!--
 * @Author:
 * @Description: 文档移交
-->
<template>
  <div class="h-full pt-10px pb-10px">
    <div class="mb-10px flex">
      <el-select
        v-model="standardId"
        placeholder="请选择"
        popper-class="visualization-select-popper"
        :popper-append-to-body="false"
        filterable
        class="mr-10px flex-1"
        @change="changeStandard"
      >
        <el-option
          v-for="item in standardList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="type"
        placeholder="请选择"
        popper-class="visualization-select-popper"
        :popper-append-to-body="false"
        filterable
        @change="changeType"
        class="w-100px"
      >
        <el-option
          v-for="item in typeList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </div>
    <div class="mb-10px">
      <el-input
        placeholder="请输入搜索关键词"
        v-model="searchKeyword"
        size="small"
        clearable
        @keypress.enter.native="searchByKeyword"
        class="icon-search__input my-5px"
      >
        <i
          slot="append"
          class="el-icon-search cursor-pointer icon-search__input"
          @click="searchByKeyword"
        ></i>
      </el-input>
    </div>
    <div class="tree-box" v-loading="treeLoading" element-loading-background="rgba(0, 0, 0, 0.5)">
      <el-tree
        v-if="showTree"
        class="h-full three-tree"
        :expand-on-click-node="false"
        :data="documentTreeList"
        :load="loadNode"
        :props="defaultProps"
        @node-click="handleNodeClick"
        :default-expanded-keys="defaultExpandedIds"
        :lazy="!isExpandAll"
        :default-expand-all="isExpandAll"
        node-key="id"
        ref="tree"
      >
        <div slot-scope="{ data }" class="flex">
          <!-- 文件夹 -->
          <img
            v-if="data.flag === 0"
            src="../../assets/images/objInfo/folder.png"
            alt=""
            class="w-21px h-21px"
          />
          <!-- 文档 -->
          <img
            v-if="data.flag === 1"
            src="../../assets/images/objInfo/file.png"
            alt=""
            class="w-21px h-21px"
          />
          <el-tooltip
            :content="`${data.object ? data.object.code : ''}【${data.name}】`"
            placement="top"
            :open-delay="500"
          >
            <span class="truncate flex-1" :id="`node-${data.name}`"
              >{{ data.object ? data.object.code : '' }}【{{ data.name }}】</span
            >
          </el-tooltip>
        </div>
      </el-tree>
    </div>

    <objDialog
      v-if="showDialog"
      width="800px"
      height="550px"
      top="120px"
      left="630px"
      :dialogForm="dialogForm"
      @closeObjInfo="closeObjInfo"
      @splitScreen="splitScreen"
      type="dialog"
      :player="player"
      :standardId="standardId"
    />
  </div>
</template>

<script>
import HandoverService from '../../service/HandoverService'
import objDialog from './ObjectInfoDyw/objDialog'

export default {
  name: 'HandoverDocuments',
  components: {
    objDialog,
  },
  props: {
    // 显示对象信息的文件弹窗
    showDocumentDialog: {
      type: Boolean,
      default: false,
    },
    player: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    showDocumentDialog(newVal) {
      if (newVal) {
        this.showDialog = true
      }
    },
  },
  data() {
    return {
      typeList: [
        { name: '目录树', id: 0 },
        { name: '专业树', id: 1 },
        { name: '类别树', id: 2 },
      ],
      type: 0,
      searchKeyword: '',
      treeLoading: false,
      showTree: true,
      documentTreeList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      defaultExpandedIds: [],
      isExpandAll: false,
      showDialog: false,
      dialogForm: {},
      standardList: [],
      standardId: '',
    }
  },
  methods: {
    // 按关键词搜索文档树
    async searchByKeyword() {
      // 关键字搜索会返回子节点
      if (this.searchKeyword) {
        this.showTree = false
        this.$nextTick(() => {
          this.isExpandAll = true
          this.showTree = true
        })
      } else {
        this.showTree = false
        this.$nextTick(() => {
          this.isExpandAll = false
          this.showTree = true
        })
      }
      this.documentTreeList = await this.getDocumentTree()
    },
    // 懒加载子节点
    async loadNode(node, resolve) {
      this.isExpandAll = false
      if (node.level === 0) {
        return
      }
      let res = []
      if (node.data.id) {
        res = await this.getDocumentTree(node.data.id)
      }
      resolve(res)
    },
    // 点击节点
    async handleNodeClick(node) {
      if (node.flag === 1) {
        // 点击文档，打开图纸页面
        const data = await this.getFileId(node.id)
        data.nodeCode = data.code
        if (!data.defaultFileId) {
          this.$message.warning(`${data.name}没有设置默认文件`)
          return
        }
        const data2 = await this.getFileName(data.defaultFileId)
        const fileType = data2.fileNameOrigin.substring(data2.fileNameOrigin.lastIndexOf('.') + 1)
        if (fileType.toLowerCase() === 'pr') {
          const data3 = await this.getMd5(node.id)
          data.md5 = data3.files[0].fileOriginMd5
          data.fileName = data2.fileNameOrigin
          data.fileIdOrigin = data3.files[0].fileIdOrigin
        } else {
          data.fileName = data2.fileName
        }
        data.fileId = data2.fileId
        data.id = node.id
        this.dialogForm = data
        this.showDialog = false
        this.$nextTick(() => {
          this.showDialog = true
        })
      }
    },
    closeObjInfo() {
      this.showDialog = false
    },
    // 分屏
    splitScreen(val) {
      this.showDialog = false
      const obj = {
        width: document.documentElement.clientWidth / 2,
        height: document.documentElement.clientHeight - 100,
        dialogForm: val,
      }
      this.sendInfoToRightDialog('mainComponent', obj)
    },
    // 传递信息给对象信息
    sendInfoToRightDialog(type, data = {}) {
      this.$emit('transferEvent', {
        toCom: { code: 'ObjectInfo', origin: 'HandoverDocuments', name: '对象信息' },
        type,
        props: {
          ...data,
          openAlarmFlicker: true,
          flickerFrequency: 500,
        },
      })
    },
    // 获取文件id
    async getFileId(id) {
      const [err, res] = await HandoverService.getFileId({
        id,
        standardId: this.standardId,
      })
      if (!err && res && res.code === 0 && res.data) {
        return res.data
      }
      return {}
    },
    // 获取文件name
    async getFileName(id) {
      const [err, res] = await HandoverService.getFileName(id)
      if (!err && res && res.code === 0 && res.data) {
        return res.data
      }
      return {}
    },
    // 获取模型MD5
    async getMd5(id) {
      const [err, res] = await HandoverService.getModelInfo(id)
      if (!err && res && res.code === 0 && res.data) {
        return res.data
      }
      return {}
    },
    // 修改类型
    changeType() {
      this.searchByKeyword()
    },
    // 文档树(Flag 【0：文件夹】【1：文档】)
    async getDocumentTree(parentId) {
      this.treeLoading = true
      const params = {
        type: this.type,
        filter: this.searchKeyword,
        id: parentId, // 父节点
        standardId: this.standardId,
      }
      const [err, res] = await HandoverService.getDocumentTree(params)
      this.treeLoading = false
      if (!err && res && res.code === 0 && res.data) {
        return res.data
      }
      return []
    },
    async getStandardList() {
      const [err, res] = await HandoverService.getStandardList()
      if (!err && res && res.code === 0 && res.data) {
        this.standardList = res.data
        this.standardId = res.data[0].id
      } else {
        this.standardList = []
        this.standardId = ''
      }
    },
    // 修改标准
    changeStandard() {
      this.searchByKeyword()
    },
  },
  async created() {
    await this.getStandardList()
    this.searchByKeyword()
  },
}
</script>

<style lang="scss" scoped>
.tree-box {
  padding: 10px;
  height: calc(100% - 92px);
  border: 1px solid #45f2eb33;
}

::v-deep.three-tree {
  overflow-y: auto;
  height: 100%;
  color: #fff;
  background-color: transparent !important;

  .el-tree-node__content:hover {
    background: #005d657f !important;
  }

  .el-tree-node.is-current > .el-tree-node__content {
    background: #005d657f !important;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background: #005d657f !important;
  }

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
  }
}
</style>
